export const SKIP_RECEPTION_NOTES = new Set([
  "67746ddf-111e-4714-a856-b15d7b4f591b", // Scan před konzultací - Praha
  "b2ba9fc0-71cf-481c-89de-b087763cd4e0", // Scan před konzultací - Brno
]);
